import { findLocationInfo_NoMatchFound } from 'owa-locstrings/lib/strings/findlocationinfo_nomatchfound.locstring.json';
import { findLocationInfo_Loading } from 'owa-locstrings/lib/strings/findlocationinfo_loading.locstring.json';
import { findLocationInfo_Searching } from 'owa-locstrings/lib/strings/findlocationinfo_searching.locstring.json';
import loc, { format } from 'owa-localize';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Spinner } from 'office-ui-fabric-react/lib/Spinner';

let styles = require('./FindLocationInfo.scss');
let classNames = require('classnames');

export interface FindLocationInfoProps {
    infoType: FindLocationInfoType;
    queryString?: string;
}

/**
 * Enum definiton for the possible states of the LocationFindControl info tip (the footer)
 */
export enum FindLocationInfoType {
    Default = 0,
    Searching, // when loading results of a query string
    NoResults, // when no results are found for the query string
    Loading, // when loading suggestions with no query strings
}

export default observer(function FindLocationInfo(props: FindLocationInfoProps) {
    switch (props.infoType) {
        case FindLocationInfoType.Searching:
            return (
                <div className={styles.container}>
                    <div className={styles.iconContainer}>
                        <Spinner className={styles.loadingSpinner} />
                    </div>
                    <div className={styles.textContainer}>
                        {format(loc(findLocationInfo_Searching), props.queryString)}
                    </div>
                </div>
            );
        case FindLocationInfoType.Loading:
            return (
                <div className={styles.container}>
                    <div className={styles.iconContainer}>
                        <Spinner className={styles.loadingSpinner} />
                    </div>
                    <div className={styles.textContainer}>{loc(findLocationInfo_Loading)}</div>
                </div>
            );
        case FindLocationInfoType.NoResults:
            return (
                <div className={styles.container}>
                    <div className={classNames(styles.textContainer, styles.noResults)}>
                        {loc(findLocationInfo_NoMatchFound)}
                    </div>
                </div>
            );
        default:
            return null;
    }
});
